<template>
  <div class="edit-billing-address">
    <h2>Edit your billing address...</h2>

    <p class="text-muted small">
      <svg
        class="bi"
        style="margin-right: 0.2em; vertical-align: text-middle"
        width="1em"
        height="1em"
        fill="currentColor"
      >
        <use
          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#exclamation-circle"
        />
      </svg>

      If you are paying by card, please ensure the address matches the
      registered address for your card, including the country. If the address is
      incorrect, your payment will fail.
    </p>

    <div class="inset-section mb-2">
      <address-input
        ref="address-input"
        :value="local_address"
        @input="updateAddress"
        @valid="validationState"
        no-name
      ></address-input>
    </div>

    <div class="text-center">
      <b-button
        variant="success"
        class="mb-2"
        size="lg"
        :disabled="!is_valid"
        @click="save"
        >Save and return to summary...</b-button
      >
    </div>
  </div>
</template>

<script>
import AddressInput from "../AddressInput.vue";
export default {
  components: { AddressInput },
  data() {
    return {
      is_valid: false,
      local_address: {},
      updated_address: false,
    };
  },
  mounted() {
    this.local_address = { ...this.billing_address };
  },
  methods: {
    validationState(is_valid) {
      this.is_valid = is_valid;
    },
    updateAddress(val) {
      this.updated_address = { ...val };
    },
    save() {
      if (this.is_valid && this.updated_address) {
        this.$store.commit(
          "checkout/set_billing_address",
          this.updated_address
        );
        this.$emit("close");
      }
    },
  },
  computed: {
    billing_address() {
      if (this.$store.state.checkout.order_data.billing.address === false) {
        return {
          Name: "Billing",
          Recipient: "",
          Address1: "",
          Address2: "",
          Address3: "",
          City: "",
          Country: "GB",
          PostCode: "",
          Telephone: "",
        };
      }
      return this.$store.state.checkout.order_data.billing.address;
    },
  },
};
</script>